import React from "react";
import classNames from "classnames";

import { Props } from "./types";
import { Allocation } from "./allocation";
import styles from "./styles.scss";

function Loader({ isTsLoader }: Props) {
  return (
    <div className={styles.allocations}>
      <div className={classNames(styles.allocation, { [styles.even]: true })}>
        <Allocation isTsLoader={isTsLoader} />
      </div>
      <div className={classNames(styles.allocation, { [styles.even]: false })}>
        <Allocation isTsLoader={isTsLoader} />
      </div>
      {!isTsLoader && (
        <div className={classNames(styles.allocation, { [styles.even]: true })}>
          <Allocation isTsLoader={isTsLoader} />
        </div>
      )}
    </div>
  );
}

export { Loader };
